import React from "react";
import { useInfiniteScroll } from "../../hooks/useInfiniteScroll";
import { InfiniteLoaderProps } from "../interfaces";

export const InfiniteLoader: React.FC<InfiniteLoaderProps> = ({
  loadMore,
  hasMore,
  loading,
  children,
  showButton = true,
}) => {
  const sentinelRef = useInfiniteScroll(loadMore, hasMore && !loading);

  return (
    <>
      {children}

      {/* sentinel для auto-load */}
      <div ref={sentinelRef} />

      {/* fallback кнопка */}
      {showButton && hasMore && (
        <div style={{ display: "flex", justifyContent: "center", padding: 16 }}>
          <button onClick={loadMore} disabled={loading}>
            {loading ? "Завантажую…" : "Показати ще"}
          </button>
        </div>
      )}

      {!hasMore && <div style={{ height: 16 }} aria-hidden="true" />}
    </>
  );
};
